// extracted by mini-css-extract-plugin
export default {"popularHeader":"i_aNxjJo","mobile":"mobile","popularTitle":"GlzHcdGV","searchWrapper":"ZVL6F4ra","searchTitle":"s3YCkjQ9"};